
import $ from "jquery"
import _pick from "lodash/pick"

interface InputScrollOptions {
  duration?: number,
  easing?:   string,
  complete?: (() => void), // Should put function here if you need
  offset?:   number, // Some extra offset on top
}

interface ScrollOptions {
  duration:   number,
  easing:     string,
  complete?:  (() => void), // Should put function here if you need
  offset:     number, // Some extra offset on top
}

/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
const defaultScrollOptions: ScrollOptions = {
  duration: 1000,
  easing:   "swing",
  complete: () => {},
  offset:   20,
}
/* eslint-enable @typescript-eslint/no-empty-function */
/* eslint-enable no-empty-function */


class StickyNavbarHandler {
  private totalOffsetForScrolling: number

  constructor(totalOffsetForScrolling = 0){
    this.totalOffsetForScrolling = totalOffsetForScrolling
  }

  public scrollTo(selectorOrElement: string | Element | JQuery, options?: InputScrollOptions) {
    const $target = $(selectorOrElement)
    const opts: ScrollOptions = Object.assign({}, defaultScrollOptions, options)

    if ( $target.length === 0 ){
      return
    }
    const target_offset = $target.offset()
    if (target_offset == null) { return }

    const totalOffset = target_offset.top - opts.offset - this.totalOffsetForScrolling
    $("html, body").animate({
      scrollTop: totalOffset,
    }, _pick(opts, "duration", "easing", "complete") )
  }

  public getTotalOffsetForScrolling() {
    return this.totalOffsetForScrolling
  }

  public setTotalOffsetForScrolling(num: number) {
    this.totalOffsetForScrolling = num
  }

  public addToTotalOffsetForScrolling(num: number) {
    this.totalOffsetForScrolling += num
  }

  public substractFromTotalOffsetForScrolling(num: number) {
    this.totalOffsetForScrolling -= num
  }
}

const instance = new StickyNavbarHandler()

export {instance as default, StickyNavbarHandler }

